<template>
   <div>
       <app-header title="Beteiligung ablehnen"></app-header>
       <div class="page">
           <div class="content">
               <h1>Wieso möchtest du die Beteiligung ablehnen?</h1>
               <span>Bitte schreibe Bligg in wenigen Worten eine kurze Begründung:</span>
           </div>
           <form>
               <input class="ablehnen">
           </form>
       </div>
       <footer>
           <form>
               <router-link :to="{name: 'meine_trends', params: {feedBackPage: 'true'}}" class="outline" tag="button"> Absenden</router-link>
           </form>
       </footer>
   </div>
</template>

<script>
    import Header from '../Header';
    export default {
        computed: {
            items() {
                return this.$store.getters.Neue;
            }
        },
        components: {
            appHeader: Header
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/css/style';
    .page{
        padding-top:60px;
        overflow: hidden;
        color: $font-color_dark;
        .content{
          padding: 35px 20px;
            h1{
                font-size:2.6rem;
                font-weight: 800;
                line-height: 30px;
                letter-spacing: -0,35px;
                margin-bottom:10px;
            }
            span{

                font-size:1.5rem;
                font-weight: 400;
                letter-spacing: -0,2px;
            }
        }
        form{
            text-align: center;
            input{
                border: none;
                border-bottom:1px $line_color solid;
                width: 90%;
                padding: 5px;
                height: 35px;
                font-size: 1.6rem;
            }
        }
    }
    header {
        background-color: $lila;
        position: fixed;
        width: 100%;
        top: 0;
        h2 {
            padding: 24px 0 3px 0;
            color: $betuszin;
            text-align: center;
            font-size:2.1rem;
            font-weight: 200;
            line-height: 28px;
            font-family: "SF UI Text Light";
            letter-spacing: -0.4375px;
        }
        img{
            position: absolute;
            right: 20px;
            top: 30px;
        }
    }


    footer{
        position: fixed;
        width: 100%;
        bottom: 0;
        height: 67px;
        background: $betuszin;
        display: table;
        form{
            display: table-cell;
            vertical-align: middle;
            text-align: center;
            button{
                font-size:1.5rem;
                margin:10px;
                padding: 14px 25px;
                margin:2px;
                border-radius: 5px;
                border: none;
                font-weight: 700;
                width:90%;
                &:first-of-type{
                    background-color: $button_full-backGroundColor;
                    color: $button-full_color;
                }
            }

        }
    }

</style>



// WEBPACK FOOTER //
// src/components/ablehnen/Ablehnen.vue